import React from 'react';
import {Navigate, useLocation, useParams} from 'react-router-dom';

interface RouteRedirectProps {
    /** Target path; ":param" tokens are filled from the matched route's params. */
    to: string;
}

/**
 * Declarative redirect for routes that moved (see Page.redirectTo in pages.ts).
 * Keeps bookmarks, user-doc links and old navbar habits working after the
 * settings redesign. The query string travels with the redirect.
 */
const RouteRedirect: React.FC<RouteRedirectProps> = ({to}) => {
    const params = useParams();
    const location = useLocation();

    const target = to.replace(/:([A-Za-z0-9_]+)/g, (token, name: string) => {
        const value = params[name];
        return value === undefined ? token : encodeURIComponent(value);
    });

    return <Navigate to={`${target}${location.search}`} replace />;
};

export default RouteRedirect;
